import { useApiMutation } from "../../../../common/infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import { IPreReservationFormSubmission } from "../../../../common/preReservationForms/models";

export interface IAppointmentWizardRequest {
  Id?: number; // Optional for edit mode
  ServiceId: number;
  EmployeeId: number;
  StartTime: string; // ISO string format
  Notes?: string;
  studioId: number; // This stays lowercase as it's a query parameter
  FormSubmission?: IPreReservationFormSubmission | null;
}

export interface IAppointmentWizardResponse {
  appointmentId: number;
  success: boolean;
  message: string;
}

/**
 * Hook to create or update an appointment using the unified wizard endpoint
 */
export const useAppointmentWizardApi = () => {
  return useApiMutation<IAppointmentWizardResponse>({
    onError: (error) => {
      // Handle appointment wizard error
      console.error("Failed to complete appointment wizard:", error);
    },
  });
};

/**
 * Helper function to create appointment wizard mutation request
 */
export const createAppointmentWizardRequest = (
  appointmentData: IAppointmentWizardRequest
): Parameters<ReturnType<typeof useAppointmentWizardApi>["mutate"]>[0] => {
  const { studioId, ...requestBody } = appointmentData;

  return {
    endpoint: endpointsMetadata.appointments.appointmentWizard,
    method: "post" as const,
    queryParams: { studioId },
    disableSuccessToast: true,
    ...requestBody,
  };
};
